import { BatchLevelSubScreen, BatchLevelSubScreenLink } from '@v2/pages/batch/details/common/enums/batchDetails.enum';
import { LevelSubScreen, NcFileBatchEventsLink, NcFileBatchEventType } from '@v2/pages/common/enums';
import { createLevelSubScreenLinking } from '@v2/pages/common/helpers';
import { navigationLevels } from '@v2/pages/machines/common/constants';
import { NCFileLevelSubScreen, NCFileLevelSubScreenLink } from '@v2/pages/nc-file/details/common/enums/ncFileDetails.enum';
import {
  ProductionOrderDetailsScreen,
  ProductionOrderDetailsScreenLink,
  ProductionOrderLevelSubScreen,
} from '../common/enums/productionOrderDetails.enum';
import {
  ProductionOrderDetailsNCFilePerformanceActive,
  ProductionOrderDetailsNCFilePerformanceNavigator,
  ProductionOrderDetailsNCFilePerformancePaid,
  ProductionOrderDetailsNCFilePerformanceProductive,
  ProductionOrderDetailsNCFilePerformanceUtilization,
  ProductionOrderDetailsNCFileEventsActive,
  ProductionOrderDetailsNCFileEventsChange,
  ProductionOrderDetailsNCFileEventsCycle,
  ProductionOrderDetailsNCFileEventsNavigator,
  ProductionOrderDetailsNCFileEventsSetup,
  ProductionOrderDetailsNCFileEventsTrace,
  ProductionOrderDetailsNCFile,
  ProductionOrderDetailsNCFileDocuments,
  ProductionOrderDetailsNCFileLinks,
  ProductionOrderDetailsNCFileTimeline,
  ProductionOrderDetailsNCFileTimes,
  ProductionOrderDetailsNCFileVersions,
  ProductionOrderDetailsNCFileTraceability,
} from '../modules/nc-file';
import {
  ProductionOrderDetailsBatchEventsActive,
  ProductionOrderDetailsBatchEventsChange,
  ProductionOrderDetailsBatchEventsCycle,
  ProductionOrderDetailsBatchEventsNavigator,
  ProductionOrderDetailsBatchEventsSetup,
  ProductionOrderDetailsBatchEventsTrace,
  ProductionOrderDetailsBatch,
  ProductionOrderDetailsBatchDocuments,
  ProductionOrderDetailsBatchTimeline,
} from '../modules/batch';
import { ProductionOrderDetailsPart, ProductionOrderDetailsPartDocuments, ProductionOrderDetailsPartTimeline } from '@v2/pages/productionOrder/modules/part';
import { ProductionOrderDetailsProductionOrder } from '@v2/pages/productionOrder/modules/productionOrder/ProductionOrderDetailsProductionOrder';
import { ProductionOrderDetailsProductionOrderDocuments } from '@v2/pages/productionOrder/modules/productionOrder/ProductionOrderDetailsProductionOrderDocuments';
import { ProductionOrderDetailsBatchNavigator } from './ProductionOrderDetailsBatchNavigator';
import { ProductionOrderDetailsProductionOrderNavigator } from './ProductionOrderDetailsJobNavigator';
import { ProductionOrderDetailsNCFileNavigator } from './ProductionOrderDetailsNCFileNavigator';
import { ProductionOrderDetailsPartNavigator } from './ProductionOrderDetailsPartNavigator';
import { timelineAvailable } from '@config/navigationRestrictions';
import { injectConditionalArrayItems } from '@helpers';
import {
  filteredBatchLevelSubScreen,
  filteredBatchLevelSubScreenLink,
  filteredNCFileLevelSubScreen,
  filteredNCFileLevelSubScreenLink,
  filteredPartLevelSubScreen,
  filteredPartLevelSubScreenLink,
  filteredProductionOrderLevelSubScreen,
  filteredProductionOrderLevelSubScreenLink,
} from '../../common/constants/base.constants';
import { ProductionOrderDetailsProductionOrderTimeline } from '@v2/pages/productionOrder/modules/productionOrder/ProductionOrderDetailsProductionOrderTimeline';
import { PartLevelSubScreen } from '@v2/pages/part/details/common/enums/partDetails.enum';

export const ProductionOrderDetailsScreenName = 'ProductionOrderDetailsV2';

export const productionOrderDetailsLinking = {
  path: 'production-order/details',
  screens: {
    [ProductionOrderDetailsScreen.PART]: {
      path: ProductionOrderDetailsScreenLink.PART,
      screens: createLevelSubScreenLinking(ProductionOrderDetailsScreen.PART, {
        levels: filteredPartLevelSubScreen,
        links: filteredPartLevelSubScreenLink,
      }),
    },
    [ProductionOrderDetailsScreen.BATCH]: {
      path: ProductionOrderDetailsScreenLink.BATCH,
      screens: createLevelSubScreenLinking(ProductionOrderDetailsScreen.BATCH, {
        levels: filteredBatchLevelSubScreen,
        links: filteredBatchLevelSubScreenLink,
        nestedScreens: {
          [BatchLevelSubScreen.TIMES]: {
            screenName: BatchLevelSubScreen.TIMES,
            items: NcFileBatchEventType,
            links: NcFileBatchEventsLink,
          },
        },
      }),
    },
    [ProductionOrderDetailsScreen.NC_FILE]: {
      path: ProductionOrderDetailsScreenLink.NC_FILE,
      screens: createLevelSubScreenLinking(ProductionOrderDetailsScreen.NC_FILE, {
        levels: filteredNCFileLevelSubScreen,
        links: filteredNCFileLevelSubScreenLink,
        nestedScreens: {
          [NCFileLevelSubScreen.TIMES]: {
            screenName: NCFileLevelSubScreen.TIMES,
            items: NcFileBatchEventType,
            links: NcFileBatchEventsLink,
          },
        },
      }),
    },
    [ProductionOrderDetailsScreen.ORDER]: {
      path: ProductionOrderDetailsScreenLink.ORDER,
      screens: createLevelSubScreenLinking(ProductionOrderDetailsScreen.ORDER, {
        levels: filteredProductionOrderLevelSubScreen,
        links: filteredProductionOrderLevelSubScreenLink,
      }),
    },
  },
};

export const productionOrderDetailsConfig = [
  { name: ProductionOrderDetailsScreen.PART, Component: ProductionOrderDetailsPartNavigator },
  { name: ProductionOrderDetailsScreen.BATCH, Component: ProductionOrderDetailsBatchNavigator },
  { name: ProductionOrderDetailsScreen.NC_FILE, Component: ProductionOrderDetailsNCFileNavigator },
  { name: ProductionOrderDetailsScreen.ORDER, Component: ProductionOrderDetailsProductionOrderNavigator },
];

export const productionOrderDetailsPartConfig = [
  {
    name: `${ProductionOrderDetailsScreen.PART}${PartLevelSubScreen.GENERAL}`,
    Component: ProductionOrderDetailsPart,
  },
  ...injectConditionalArrayItems(timelineAvailable, {
    name: `${ProductionOrderDetailsScreen.PART}${PartLevelSubScreen.TIMELINE}`,
    Component: ProductionOrderDetailsPartTimeline,
  }),
  // {
  //   name: `${ProductionOrderDetailsScreen.PART}${PartLevelSubScreen.TIMES}`,
  //   Component: JobDetailsPart,
  // },
  // {
  // {
  //   name: `${ProductionOrderDetailsScreen.PART}${PartLevelSubScreen.VERSIONS}`,
  //   Component: JobDetailsPart,
  // },
  // {
  //   name: `${ProductionOrderDetailsScreen.PART}${PartLevelSubScreen.LINKS}`,
  //   Component: JobDetailsPart,
  // },
  {
    name: `${ProductionOrderDetailsScreen.PART}${PartLevelSubScreen.DOCUMENTS}`,
    Component: ProductionOrderDetailsPartDocuments,
  },
];

export const productionOrderDetailsBatchConfig = [
  {
    name: `${ProductionOrderDetailsScreen.BATCH}${BatchLevelSubScreen.GENERAL}`,
    Component: ProductionOrderDetailsBatch,
  },
  ...injectConditionalArrayItems(timelineAvailable, {
    name: `${ProductionOrderDetailsScreen.BATCH}${BatchLevelSubScreen.TIMELINE}`,
    Component: ProductionOrderDetailsBatchTimeline,
  }),
  {
    name: `${ProductionOrderDetailsScreen.BATCH}${BatchLevelSubScreen.TIMES}`,
    Component: ProductionOrderDetailsBatchEventsNavigator,
  },
  // {
  //   name: `${ProductionOrderDetailsScreen.BATCH}${BatchLevelSubScreen.TIMES}`,
  //   Component: JobDetailsBatch,
  // },
  {
    name: `${ProductionOrderDetailsScreen.BATCH}${BatchLevelSubScreen.DOCUMENTS}`,
    Component: ProductionOrderDetailsBatchDocuments,
  },
];

export const productionOrderDetailsNCFileConfig = [
  {
    name: `${ProductionOrderDetailsScreen.NC_FILE}${NCFileLevelSubScreen.GENERAL}`,
    Component: ProductionOrderDetailsNCFile,
  },
  // Based on task SF-4963
  // ...injectConditionalArrayItems(timelineAvailable, {
  //   name: `${ProductionOrderDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMELINE}`,
  //   Component: ProductionOrderDetailsNCFileTimeline,
  // }),

  // {
  //   name: `${ProductionOrderDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}`,
  //   Component: ProductionOrderDetailsNCFileTimes,
  // },
  {
    name: `${ProductionOrderDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}`,
    Component: ProductionOrderDetailsNCFileEventsNavigator,
  },
  {
    name: `${ProductionOrderDetailsScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}`,
    Component: ProductionOrderDetailsNCFilePerformanceNavigator,
  },
  {
    name: `${ProductionOrderDetailsScreen.NC_FILE}${NCFileLevelSubScreen.VERSIONS}`,
    Component: ProductionOrderDetailsNCFileVersions,
  },
  {
    name: `${ProductionOrderDetailsScreen.NC_FILE}${NCFileLevelSubScreen.LINKS}`,
    Component: ProductionOrderDetailsNCFileLinks,
  },
  {
    name: `${ProductionOrderDetailsScreen.NC_FILE}${NCFileLevelSubScreen.DOCUMENTS}`,
    Component: ProductionOrderDetailsNCFileDocuments,
  },
  {
    name: `${ProductionOrderDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TRACEABILITY}`,
    Component: ProductionOrderDetailsNCFileTraceability,
  }
];

export const productionOrderDetailsJobsConfig = [
  {
    name: `${ProductionOrderDetailsScreen.ORDER}${ProductionOrderLevelSubScreen.GENERAL}`,
    Component: ProductionOrderDetailsProductionOrder,
  },
  ...injectConditionalArrayItems(timelineAvailable, {
    name: `${ProductionOrderDetailsScreen.ORDER}${ProductionOrderLevelSubScreen.TIMELINE}`,
    Component: ProductionOrderDetailsProductionOrderTimeline,
  }),
  // {
  //   name: `${ProductionOrderDetailsScreen.JOBS}${ProductionOrderLevelSubScreen.TIMES}`,
  //   Component: JobDetailsJobs,
  // },
  // {
  //   name: `${ProductionOrderDetailsScreen.JOBS}${ProductionOrderLevelSubScreen.PERFORMANCE}`,
  //   Component: JobDetailsJobs,
  // },
  // {
  //   name: `${ProductionOrderDetailsScreen.JOBS}${ProductionOrderLevelSubScreen.VERSIONS}`,
  //   Component: JobDetailsJobs,
  // },
  // {
  //   name: `${ProductionOrderDetailsScreen.JOBS}${ProductionOrderLevelSubScreen.LINKS}`,
  //   Component: JobDetailsJobs,
  // },
  {
    name: `${ProductionOrderDetailsScreen.ORDER}${ProductionOrderLevelSubScreen.DOCUMENTS}`,
    Component: ProductionOrderDetailsProductionOrderDocuments,
  },
];

export const ncFilePerformanceConfig = [
  {
    name: `${ProductionOrderDetailsScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}${navigationLevels.metricTypes.active}`,
    Component: ProductionOrderDetailsNCFilePerformanceActive,
  },
  {
    name: `${ProductionOrderDetailsScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}${navigationLevels.metricTypes.productive}`,
    Component: ProductionOrderDetailsNCFilePerformanceProductive,
  },
  {
    name: `${ProductionOrderDetailsScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}${navigationLevels.metricTypes.paid}`,
    Component: ProductionOrderDetailsNCFilePerformancePaid,
  },
  {
    name: `${ProductionOrderDetailsScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}${navigationLevels.metricTypes.utilization}`,
    Component: ProductionOrderDetailsNCFilePerformanceUtilization,
  },
];

export const ncFileEventsConfig = [
  {
    name: `${ProductionOrderDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.CYCLE}`,
    Component: ProductionOrderDetailsNCFileEventsCycle,
  },
  {
    name: `${ProductionOrderDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.ACTIVE}`,
    Component: ProductionOrderDetailsNCFileEventsActive,
  },
  {
    name: `${ProductionOrderDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.CHANGE}`,
    Component: ProductionOrderDetailsNCFileEventsChange,
  },
  {
    name: `${ProductionOrderDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.SETUP}`,
    Component: ProductionOrderDetailsNCFileEventsSetup,
  },
  {
    name: `${ProductionOrderDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.TRACE}`,
    Component: ProductionOrderDetailsNCFileEventsTrace,
  },
];

export const batchEventsConfig = [
  {
    name: `${ProductionOrderDetailsScreen.BATCH}${BatchLevelSubScreen.TIMES}${NcFileBatchEventType.CYCLE}`,
    Component: ProductionOrderDetailsBatchEventsCycle,
  },
  {
    name: `${ProductionOrderDetailsScreen.BATCH}${BatchLevelSubScreen.TIMES}${NcFileBatchEventType.ACTIVE}`,
    Component: ProductionOrderDetailsBatchEventsActive,
  },
  {
    name: `${ProductionOrderDetailsScreen.BATCH}${BatchLevelSubScreen.TIMES}${NcFileBatchEventType.CHANGE}`,
    Component: ProductionOrderDetailsBatchEventsChange,
  },
  {
    name: `${ProductionOrderDetailsScreen.BATCH}${BatchLevelSubScreen.TIMES}${NcFileBatchEventType.SETUP}`,
    Component: ProductionOrderDetailsBatchEventsSetup,
  },
  {
    name: `${ProductionOrderDetailsScreen.BATCH}${BatchLevelSubScreen.TIMES}${NcFileBatchEventType.TRACE}`,
    Component: ProductionOrderDetailsBatchEventsTrace,
  },
];
